<template>

    <div class="tuto">

        <div class="tuto__bloc" :class="{'tuto__bloc_end-desktop': isEndDesktop}">

            <div class="tuto__header" v-show="step !== ENUM.STEPS.TUTO.END">

                <div class="tuto__header__navigation">
                    <img :src="stepInfo.navigation" class="tuto__header__tabs" v-show="!isDesktop">
                </div>

                <div class="tuto__header__close pointer" @click="skipTuto">
                    <img src="/img/newsletters-v2/x-blue.svg" class="img__20 mr__4">
                    <p class="text-lSemibold color__aquamarine">{{ $t('skip_tutorial_cleaning') }}</p>
                </div>

            </div>

            <div class="tuto__body">

                <img src="/img/newsletters-v2/foxy.svg" class="img__72 mb-24"
                     v-show="isDesktop && step === ENUM.STEPS.TUTO.SPAMS">

                <markdown :text="stepInfo.title"
                          :class="{'title-baseSemibold': isDesktop, 'text-xlSemibold-2': !isDesktop}"
                          :color="'#f04871'"></markdown>

                <div class="tuto__image__container"
                     :class="{'tuto__image__container__min': step === ENUM.STEPS.TUTO.END}">

                    <tuto-cards v-show="!isDesktop" :step="step" @next="next"></tuto-cards>

                    <div class="tuto__image__image" :style="imageStyle"  v-show="stepInfo.image"></div>

                </div>
                <div class="tuto__header__navigation" v-show="showDesktopDetails">
                    <img :src="stepInfo.navigation" class="tuto__header__tabs">

                    <button class="ds__button__medium ds__button__secondary mt__32 text-xlSemibold"
                            @click="next">
                        {{ $t('global_cta_next') }}
                    </button>
                </div>

                <div v-show="step === ENUM.STEPS.TUTO.END" class="tuto__end">

                    <p class="title-baseSemibold mt__24">{{ stepInfo.subtitle }}</p>
                    <p class="text-xlRegular">{{ stepInfo.text }}</p>

                    <button class="ds__button__medium ds__button__secondary mt__32 text-xlSemibold"
                            @click="close">
                        {{ $t('cleaning_cards_tuto_cta') }}
                    </button>
                </div>
            </div>

            <div class="tuto__footer" v-show="showActionBar || step === ENUM.STEPS.TUTO.SPAMS">

                <div v-show="showActionBar" class="tuto__footer__actions">
                    <div class="tuto__footer__btn tuto__footer__btn__red"
                         :class="{'tuto__footer__btn__ghost': step !== ENUM.STEPS.TUTO.UNSUBSCRIBES}"
                         @click="ctaActionBar(ENUM.STEPS.TUTO.UNSUBSCRIBES)">
                        <img src="/img/newsletters-v2/delete-white-auto.svg" class="img__28">
                    </div>

                    <div class="tuto__footer__btn tuto__footer__btn__orange"
                         :class="{'tuto__footer__btn__ghost': step !== ENUM.STEPS.TUTO.DELETE}"
                         @click="ctaActionBar(ENUM.STEPS.TUTO.DELETE)">
                        <img src="/img/newsletters-v2/delete-white-simple.svg" class="img__28">
                    </div>

                    <div class="tuto__footer__btn tuto__footer__btn__green"
                         :class="{'tuto__footer__btn__ghost': step !== ENUM.STEPS.TUTO.KEEP}"
                         @click="ctaActionBar(ENUM.STEPS.TUTO.KEEP)">
                        <img src="/img/newsletters-v2/archive-i-os-white.svg" class="img__28">
                    </div>
                </div>

                <div v-show="step === ENUM.STEPS.TUTO.SPAMS" class="tuto__footer__spams">

                    <p class="text-xlSemibold-2">{{ stepInfo.subtitle }}</p>
                    <p class="text-xlRegular">{{ stepInfo.text }}</p>


                    <div class="tuto__header__navigation mt__32" v-show="isDesktop">
                        <img :src="stepInfo.navigation" class="tuto__header__tabs">
                    </div>

                    <button
                            class="ds__button__medium ds__button__secondary ds__button__fluid mt__24 text-xlSemibold"
                            @click="next">{{ $t('global_cta_understood') }}
                    </button>

                </div>
            </div>
        </div>
    </div>

</template>

<script>
import Vuex from 'vuex'

import ENUM from '@/assets/ENUM'

import Tag from '@/modules/tag'

import Storage from '@/helpers/storage'

import Markdown from '@/components/Markdown'
import TutoCards from '@/components/newsletters-v2/tuto/TutoCards'

export default {

    name: 'tuto',

    components: {
        Markdown,
        TutoCards
    },

    computed: {

        ...Vuex.mapGetters([
            'lang',
            'user'
        ]),

        ENUM() {
            return ENUM
        },

        stepInfo() {

            return this.isDesktop
                ? this.stepInfoDesktop
                : this.stepInfoMobile
        },

        stepInfoMobile() {

            switch (this.step) {
                case ENUM.STEPS.TUTO.UNSUBSCRIBES:
                    return {
                        title: this.$t('slide_left'),
                        navigation: '/img/newsletters-v2/tabs-0.svg'
                    }
                case ENUM.STEPS.TUTO.DELETE:
                    return {
                        title: this.$t('slide_up'),
                        navigation: '/img/newsletters-v2/tabs-1.svg'
                    }
                case ENUM.STEPS.TUTO.KEEP:
                    return {
                        title: this.$t('slide_right'),
                        navigation: '/img/newsletters-v2/tabs-2.svg'
                    }
                case ENUM.STEPS.TUTO.SPAMS:
                    return {
                        image: this.getScreenSpamImage(),
                        title: this.$t('tutorial_spams_newsletters_title'),
                        subtitle: this.$t('tutorial_spam_beta_1'),
                        text: this.$t('tutorial_spam_beta_2'),
                        navigation: '/img/newsletters-v2/tabs-3.svg'
                    }
                case ENUM.STEPS.TUTO.END:
                    return {
                        image: '/img/newsletters-v2/foxy.webp',
                        subtitle: this.$tc('cleaning_cards_tuto_title', 0, {firstname: this.user.firstname}),
                        text: this.$t('cleaning_cards_tuto_text'),
                        navigation: '/img/newsletters-v2/tabs-4.svg'
                    }
                default:
                    return {}
            }
        },

        stepInfoDesktop() {

            switch (this.step) {
                case ENUM.STEPS.TUTO.UNSUBSCRIBES:
                    return {
                        image: '/img/newsletters-v2/tuto-card-desktop-unsubscribe.svg',
                        title: this.$t('keyboard_left'),
                        navigation: '/img/newsletters-v2/tabs-0.svg'
                    }
                case ENUM.STEPS.TUTO.DELETE:
                    return {
                        image: '/img/newsletters-v2/tuto-card-desktop-delete.svg',
                        title: this.$t('keyboard_up'),
                        navigation: '/img/newsletters-v2/tabs-1.svg'
                    }
                case ENUM.STEPS.TUTO.KEEP:
                    return {
                        image: '/img/newsletters-v2/tuto-card-desktop-keep.svg',
                        title: this.$t('keyboard_right'),
                        navigation: '/img/newsletters-v2/tabs-2.svg'
                    }
                case ENUM.STEPS.TUTO.SPAMS:
                    return {
                        image: this.getScreenSpamImage(),
                        title: this.$t('tutorial_spams_newsletters_title'),
                        subtitle: this.$t('tutorial_spam_beta_1'),
                        text: this.$t('tutorial_spam_beta_2'),
                        navigation: '/img/newsletters-v2/tabs-3.svg'
                    }
                case ENUM.STEPS.TUTO.END:
                    return {
                        image: '/img/newsletters-v2/foxy.webp',
                        subtitle: this.$tc('cleaning_cards_tuto_title', 0, {firstname: this.user.firstname}),
                        text: this.$t('cleaning_cards_tuto_text'),
                        navigation: '/img/newsletters-v2/tabs-4.svg'
                    }
                default:
                    return {}
            }
        },

        showActionBar() {
            return !this.isDesktop && (this.step === ENUM.STEPS.TUTO.UNSUBSCRIBES || this.step === ENUM.STEPS.TUTO.DELETE || this.step === ENUM.STEPS.TUTO.KEEP)
        },

        showDesktopDetails() {
            return this.isDesktop && (this.step === ENUM.STEPS.TUTO.UNSUBSCRIBES || this.step === ENUM.STEPS.TUTO.DELETE || this.step === ENUM.STEPS.TUTO.KEEP)
        },

        isEndDesktop() {
            return this.isDesktop && this.step === ENUM.STEPS.TUTO.END
        },

        imageStyle() {
            return `background-image: url('${this.stepInfo.image}');`
        }

    },

    data() {
        return {
            step: ''
        }
    },

    mounted() {
        window.addEventListener('keydown', this.keydown)
        this.updateIsCardTuto(true)
        this.next()
    },

    methods: {

        ...Vuex.mapActions(['updateIsCardTuto']),

        next() {
            switch (this.step) {
                case ENUM.STEPS.TUTO.UNSUBSCRIBES:
                    Tag.pageViewGA(this, 'cleaning_tuto_2')
                    this.step = ENUM.STEPS.TUTO.DELETE
                    break
                case ENUM.STEPS.TUTO.DELETE:
                    Tag.pageViewGA(this, 'cleaning_tuto_3')
                    this.step = ENUM.STEPS.TUTO.KEEP
                    break
                case ENUM.STEPS.TUTO.KEEP:
                    Tag.pageViewGA(this, 'cleaning_tuto_4')
                    this.step = ENUM.STEPS.TUTO.SPAMS
                    break
                case ENUM.STEPS.TUTO.SPAMS:
                    Tag.pageViewGA(this, 'cleaning_tuto_5')
                    this.step = ENUM.STEPS.TUTO.END
                    break
                case ENUM.STEPS.TUTO.END:
                    this.step = this.close()
                    break
                default:
                    Tag.pageViewGA(this, 'cleaning_tuto_1')
                    this.step = ENUM.STEPS.TUTO.UNSUBSCRIBES
            }
        },

        skipTuto() {
            Tag.clickGA(this, 'skip_tutorial')
            this.close()
        },

        ctaActionBar(step) {
            if (step === this.step) {
                this.next()
            }
        },

        close() {
            Storage.setItem(Storage.KEYS.TUTO_NEWSLETTERS, true)
            this.$emit('close')
        },

        keydown(event) {
            switch (event.keyCode) {
                case 37:
                    if (this.step === ENUM.STEPS.TUTO.UNSUBSCRIBES) {
                        this.next()
                    }
                    break
                case 38:
                    if (this.step === ENUM.STEPS.TUTO.DELETE) {
                        this.next()
                    }
                    break
                case 39:
                    if (this.step === ENUM.STEPS.TUTO.KEEP) {
                        this.next()
                    }
                    break
            }
        },

        getScreenSpamImage() {

            switch (this.lang) {
                case 'ar-sa':
                case 'da-dk':
                case 'de-de':
                case 'en-gb':
                case 'es-es':
                case 'fr-fr':
                case 'hi-in':
                case 'it-it':
                case 'ja-jp':
                case 'nl-be':
                case 'nl-nl':
                case 'pl-pl':
                case 'pt-pt':
                case 'sv-se':
                    return `/img/newsletters-v2/screenspam/${this.isDesktop ? 'desktop' : 'mobile'}/screen-spam-${this.lang}.svg`
                default:
                    return `/img/newsletters-v2/screenspam/${this.isDesktop ? 'desktop' : 'mobile'}/screen-spam-default.svg`
            }
        }
    },

    destroyed() {
        this.updateIsCardTuto(false)
        window.removeEventListener('keydown', this.keydown)
    }

}
</script>

<style lang="scss" scoped>

.tuto {
    display: flex;
    flex-grow: 1;
    align-items: center;
    justify-content: center;

    @media screen and (min-width: $above-tablet-length) {
        background-image: url("/img/newsletters-v2/background-clouds.svg");
        background-repeat: no-repeat;
        background-size: cover;
        padding: 32px;
    }

    &__bloc {
        background-color: $timberwolf;
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        overflow: hidden;
        height: 100%;

        @media screen and (min-width: $above-tablet-length) {
            max-width: 741px;
            max-height: 811px;
            border-radius: 16px;
            box-shadow: 0 8px 32px 0 rgba(17, 17, 26, 0.05), 0 4px 16px 0 rgba(17, 17, 26, 0.05);
            padding: 32px;
        }

        &_end-desktop {
            height: inherit;
        }
    }

    &__header {
        display: flex;
        flex-direction: row;
        padding: 16px;
        align-items: center;
        justify-content: space-between;

        &__navigation {

        }

        &__tabs {
            height: 10px;

            &:lang(ar-sa) {
                transform: scaleX(-1);
            }
        }

        &__close {
            display: flex;
            flex-direction: row;
            align-items: center;
        }
    }

    &__body {
        padding: 16px;
        display: flex;
        flex-grow: 1;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    &__end {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    &__image {

        &__card {
            @media screen and (min-width: $above-tablet-length) {
                width: 100%;
                object-fit: contain;
            }
        }

        &__image {
            width: 100%;
            flex: 1;
            background-repeat: no-repeat;
            background-position: center;
            background-size: contain;
            min-height: 80px;
        }

        &__foxy {
            width: 60px;
            object-fit: contain;
        }

        &__container {
            display: flex;
            flex-direction: column;
            align-items: center;
            flex-grow: 1;
            justify-content: center;
            width: 100%;

            &__min {
                flex-grow: initial;
            }
        }
    }

    &__footer {
        padding: 16px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;

        &__actions {
            display: flex;
            flex-direction: row;
            &:lang(ar-sa) {
                flex-direction: row-reverse;
            }
        }

        &__btn {
            padding: 14px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 100px;
            margin: 0 12px;

            &__red {
                background-color: $raspberry;
                border: solid 4px #fbc5d2;
            }

            &__orange {
                background-color: $sunset;
                border: solid 4px #f9d3b9;
            }

            &__green {
                background-color: $lime;
                border: solid 4px #aef1dc;
            }

            &__ghost {
                opacity: 0.4;
            }
        }

        &__spams {
            display: flex;
            flex-direction: column;
            align-items: center;
        }
    }
}

</style>
